import CryptoJS from 'crypto-js';

// Global context (injected by server)
const getContext = () => {
    return window.__BOOKING_CTX__ || {
        seed: null,
        sessionId: null,
        issuedAt: 0,
        eventId: 0 // Initialize if missing
    };
};

// Initialize eventId if not present
if (window.__BOOKING_CTX__ && typeof window.__BOOKING_CTX__.eventId === 'undefined') {
    window.__BOOKING_CTX__.eventId = 0;
}

export const getSeed = () => {
    const ctx = getContext();
    return ctx.seed;
};

export const updateSeed = (newSeed) => {
    if (window.__BOOKING_CTX__) {
        console.log('[Security] Rotating Seed');
        window.__BOOKING_CTX__.seed = newSeed;
    }
};

export const initSecurityContext = (contextData) => {
    if (!window.__BOOKING_CTX__) {
        // console.log('[Security] Initializing Context from API');
        window.__BOOKING_CTX__ = {
            seed: contextData.seed,
            sessionId: contextData.sessionId,
            issuedAt: contextData.issuedAt,
            eventId: 0
        };
    }
};

export const getSessionId = () => {
    return getContext().sessionId;
};

export const generateClientToken = () => {
    const ctx = getContext();
    const seed = ctx.seed;
    const sessionId = ctx.sessionId;

    if (!seed || !sessionId) {
        console.warn('[Security] Missing seed or session. Reload required.');
        return null;
    }

    // Increment Event ID
    ctx.eventId = (ctx.eventId || 0) + 1;
    const eventId = ctx.eventId;

    // Generate Nonce (random 8 chars)
    const nonce = Math.random().toString(36).substring(2, 10);
    const timestamp = Date.now();

    // Payload: sessionId|nonce|eventId|timestamp
    // Must match server computeToken logic exactly
    const payload = `${sessionId}|${nonce}|${eventId}|${timestamp}`;

    // HMAC-SHA256
    const signature = CryptoJS.HmacSHA256(payload, seed).toString(CryptoJS.enc.Hex);

    return {
        'x-fresh-token': signature,
        'x-client-nonce': nonce,
        'x-ui-event-id': eventId.toString(),
        'x-timestamp': timestamp.toString(),
        'x-session-id': sessionId
    };
};
